import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import { Observable, pipe } from 'rxjs';
import {catchError, map} from 'rxjs/operators'
import { CommonService } from './common-service.service';
import { HttpService } from './http.service';
import { environment } from 'src/environments/environment';
import { GHAllocationModelMap, GHReviewModelMap, GuestHouseAllocationList, GuestHouseBookingModelMap } from '../model/guest-house.model';
@Injectable({
  providedIn: 'root'
})
export class GuestHouseBookingService{
hostname=environment.apiEndpoint;
guestHouseAllocateObj:GuestHouseAllocationList;
modelMap: GuestHouseBookingModelMap = new GuestHouseBookingModelMap();
ghReviewModelMap: GHReviewModelMap = new GHReviewModelMap();
ghAllocationModelMap: GHAllocationModelMap = new GHAllocationModelMap();
constructor(private _http : HttpClient, private commonService: CommonService, private httpService: HttpService) { }

  PostGuestHouseBooking(servicePath:any,data : any){
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this._http.post(this.hostname + servicePath, data, httpOptions).pipe(catchError(this.handleError));
  }

  GetGuestHouseBooking(servicePath:any,data:any){
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this._http.get<any>(this.hostname + servicePath, httpOptions).pipe(catchError(this.handleError))
  }

  ViewGuestHouseBooking(servicePath:any){
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this._http.get<any>(this.hostname + servicePath, httpOptions).pipe(catchError(this.handleError))
  }
  getSystemDate(servicePath:any){
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this._http.get<any>(this.hostname + servicePath, httpOptions).pipe(catchError(this.handleError))
  }
  private handleError(error: HttpErrorResponse) {
    console.log(error)
    return Observable.throw(error.message || "Server Error")
  }
}
